import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import AddingMinutesPage from './AddingMinutesPage';

interface AddingMinutesPageWrapperProps {
  currentSettings?: any;
}

const AddingMinutesPageWrapper = ({ currentSettings }: AddingMinutesPageWrapperProps) => {
  const navigate = useNavigate();
  const location = useLocation();

  // Extract URL parameters
  const urlParams = new URLSearchParams(location.search);
  const leave_id = urlParams.get('leave_id') || '';
  const isTherapist = urlParams.get('isTherapist') === 'true';
  const isReschedule = urlParams.get('isReschedule') === 'true';
  const make_id = urlParams.get('make_id') || '';
  const code = urlParams.get('code') || '';
  const categoryId = urlParams.get('categoryId') || '';
  const childId = urlParams.get('childId') || '';

  // Navigation handlers
  const handleNavigate = (route: string, params?: any) => {
    const queryString = params ? `?${new URLSearchParams(params).toString()}` : '';
    navigate(`/${route}${queryString}`);
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <AddingMinutesPage
      leave_id={leave_id}
      isTherapist={isTherapist}
      isReschedule={isReschedule}
      make_id={make_id}
      code={code}
      categoryId={categoryId}
      childId={childId}
      currentSettings={currentSettings}
      onNavigate={handleNavigate}
      onGoBack={handleGoBack}
    />
  );
};

const mapStateToProps = (state: any) => {
  return {
    currentSettings: state.currentSettings,
  };
};

export default connect(mapStateToProps)(withTranslation()(AddingMinutesPageWrapper));
